import React, { useCallback, useState } from 'react';

import { formatISO } from 'date-fns';

import { CancellationPolicy } from '@lt/components';
import MobilePopupBottom from '@lt/components/components/MobilePopupBottom';

const { CancellationPolicyDesktop, CancellationPolicyMobile } =
  CancellationPolicy;

const CancellationPolicyContainer = (props) => {
  const {
    ensurancePrice,
    cancellationPolicy,
    isMobile = false,
    showEnsurance = false,
    checkout = false,
    title = '',
    tooltipText = '',
    onEnsuranceBtnClick = Function.prototype,
    showBackground = true,
    showPopup = false,
    isHotelOnly,
    insuranceSelected = false,
  } = props;

  const [isCollapsed, setIsCollapsed] = useState(true);

  const uncollapse = useCallback(() => {
    setIsCollapsed(false);
  }, [setIsCollapsed]);

  const collapse = useCallback(() => {
    setIsCollapsed(true);
  }, [setIsCollapsed]);

  const ensuranceClickHandler = useCallback(() => {
    onEnsuranceBtnClick();
  }, [onEnsuranceBtnClick]);

  const hasCancellationPolicy = Boolean(cancellationPolicy);

  if (!hasCancellationPolicy) {
    return null;
  }

  if (!checkout && cancellationPolicy.kind !== 'flexible' && !isHotelOnly) {
    return null;
  }

  const cancellationPolicyProps = {
    data: cancellationPolicy,
    title,
    tooltipText,
    nowDateISO: formatISO(new Date(), { representation: 'complete' }),
    ensurancePrice: showEnsurance ? ensurancePrice : undefined,
    onGetEnsuranceClick: ensuranceClickHandler,
    isCollapsed,
    onDetailsClick: uncollapse,
    isHotelOnly,
    insuranceSelected,
  };

  if (isMobile) {
    return (
      <>
        <CancellationPolicyMobile
          {...cancellationPolicyProps}
          showBackground={showBackground}
          isCollapsed
          onDetailsClick={uncollapse}
        />
        {!isCollapsed ? (
          <MobilePopupBottom
            className="BottomPopup"
            visible={!isCollapsed}
            onClick={collapse}
          >
            <CancellationPolicyMobile
              {...cancellationPolicyProps}
              isCollapsed={false}
              onDetailsClick={null}
            />
          </MobilePopupBottom>
        ) : null}
      </>
    );
  }
  return (
    <CancellationPolicyDesktop
      {...cancellationPolicyProps}
      showBackground={showBackground}
      showPopup={showPopup}
      PopupComponent={
        <CancellationPolicyMobile
          {...cancellationPolicyProps}
          tooltipText={tooltipText}
          isCollapsed={false}
          onDetailsClick={null}
        />
      }
    />
  );
};

export default CancellationPolicyContainer;
